import { Chip, Icon, Tooltip } from '@mui/material';

export default function Number(props) {
    const chipData = {
        title: props.value,
        label: props.filter.label
    };

    const { title, label } = chipData;

    return (
        <Tooltip title={title} arrow>
            <Chip
                label={label}
                onClick={props.onClick}
                onDelete={() => {
                    props.handleDelete([props.filter.name, props.filter.minName, props.filter.maxName]);
                }}
                deleteIcon={<Icon>close</Icon>}
            />
        </Tooltip>
    );
}
